<div class="sis-app-footer" style="align-items: center;">
        <mat-dialog-actions>


                <div class="flex-footer-left" style="align-items: center; width: 50%;">


                        <tyl-button *ngIf="loginSettings.V10===false" style="float:left;" image="queue.png" label="Queue"
                                translate (clickEvent)="openQueueList()"></tyl-button>

                        <tyl-button *ngIf="loginSettings.V10===true && reportModeIsAllReports()" style="float:left;"
                                image="previous arrow.png" label="My Reports" translate
                                (clickEvent)="showMyReportsComponent()"></tyl-button>
                        <tyl-button *ngIf="loginSettings.V10===true && showNoFoldersMessage && reportModeIsMyReports()"
                                style="float:right;" image="add.png" label="Add Entry" translate
                                (clickEvent)="addMyReportsEntryClick()">
                        </tyl-button>
                        <tyl-button *ngIf="loginSettings.V10===true && !showNoFoldersMessage && reportModeIsMyReports()"
                                style="float:left;" image="Expand All.png" label="Expand All" translate
                                (clickEvent)="expandAll(true)">
                        </tyl-button>
                        <tyl-button *ngIf="loginSettings.V10===true && !showNoFoldersMessage && reportModeIsMyReports()"
                                style="float:left;" image="Collapse All.png" label="Collapse All" translate
                                (clickEvent)="expandAll(false)">
                        </tyl-button>

                </div>

                <div class="flex-footer-right" style="align-items: center; width: 50%;">

                        <tyl-button *ngIf='showAutomatedTestsButton' style="float:left;" image="listnocircle.png"
                                label="Automated Tests" translate (clickEvent)="openAutomatedTestingSetup()">
                        </tyl-button>

                        <tyl-button *ngIf="loginSettings.V10===true && !hideReportToArchiveButton" style="float:left;"
                                image="listnocircle.png" label="Report Archives" translate
                                (clickEvent)="openArchiveProcess()"></tyl-button>

                        <tyl-button *ngIf="loginSettings.V10===true && !hideFoldersButton && reportModeIsMyReports()"
                                style="float:left;" image="listnocircle.png" label="Report Folders" translate
                                (clickEvent)="openReportFoldersWindow()"></tyl-button>


                        <tyl-button *ngIf="loginSettings.V10 === true && reportModeIsMyReports()" style="float:right;"
                                image="next arrow.png" label="All Reports" translate
                                (clickEvent)="showAllReportsComponent()"></tyl-button>


                        <tyl-button style="float:right;" image="cancel.png" translate label="Close"
                                *ngIf="loginSettings.V10===true" (clickEvent)="closeClick()"></tyl-button>

                        <tyl-button *ngIf="loginSettings.V10 === false && loginSettings.EnableMyReports === true"
                                style="float:right;" image="next arrow.png" label="My Reports" translate
                                (clickEvent)="v9MyReportsClick()"></tyl-button>


                </div>
        </mat-dialog-actions>
</div>